document.addEventListener("DOMContentLoaded", function () {

    const widget = document.getElementById("levora-floating-ugc");

    if (!widget) return;

    // Hide initially
    widget.style.display = "none";

    // Show after 2 seconds
    setTimeout(function () {

        widget.style.display = "block";

        requestAnimationFrame(() => {
            widget.classList.add("show");
        });

    }, 2000);


     const video = document.querySelector(".levora-video-player");

    if (!video) return;

    video.style.opacity = "0";

    video.addEventListener("playing", () => {
        video.style.opacity = "1";
    });

    // Close button

    const closeBtn = widget.querySelector(".levora-close");

    if (closeBtn) {

        closeBtn.addEventListener("click", function () {

            widget.classList.remove("show");

            setTimeout(function () {

                widget.style.display = "none";

            }, 350);

        });

    }

});

/*==========================
Video Fade In
==========================*/

const ugcVideo = document.querySelector('.levora-video-player');

if (ugcVideo) {

    function showVideo() {
        ugcVideo.style.opacity = "1";
    }

    ugcVideo.addEventListener("loadeddata", showVideo);
    ugcVideo.addEventListener("canplay", showVideo);
    ugcVideo.addEventListener("playing", showVideo);

    if (ugcVideo.readyState >= 2) {
        showVideo();
    }
}